import { getBaseUrl } from "./get-base-url";

const HEALTH_PROBE_TIMEOUT_MS = 2000;

/** `navigator.onLine` = NIC state only, stays true behind captive portal, dead VPN, blocked API. Probe for truth. */
export async function isApiReachable(): Promise<boolean> {
  if (!window.navigator.onLine) {
    return false;
  }

  try {
    // No credentials: probe must not depend on session state.
    // no-store: a cached 200 from before the outage must never satisfy this probe.
    const response = await fetch(`${getBaseUrl()}/health`, {
      cache: "no-store",
      signal: AbortSignal.timeout(HEALTH_PROBE_TIMEOUT_MS),
    });
    return response.ok;
  } catch {
    return false;
  }
}
